exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".imageViewerViewport {\n  width: 100%;\n  height: 100%;\n/* background-size: cover; */\n  background-size: 100% 100%;\n  outline: 0 !important;\n  line-height: 0px;\n  overflow: hidden;\n  cursor: default;\n}\n.hide-cursor {\n  cursor: none;\n}\n", ""]);

